import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ApiService } from "./api-service";
import { BehaviorSubject, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TechnicalTrainingService {

  private updateTechnicalResponse = new BehaviorSubject<any>(null);
  response$ = this.updateTechnicalResponse.asObservable();

  constructor(private api: ApiService) {}

  addTechnicalTraining(body) {
    const url = `/training`;
    return this.api.post(url, body);
  }

  getTechnicalTraining(id) {
    const url = `/applicant/${id}/training`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  deleteTechnicalTraining(id) {
    const url = `/training/${id}`;
    return this.api.delete(url);
  }

  updateTechnicalTraining(body) {
    const url = `/training`;
    return this.api.put(url, body);
  }

  getAllTrainings() {
    const url = `/trainings`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  sendResponse(response: any) {
    this.updateTechnicalResponse.next(response);
  }
}
